/** Provider namespaces can host other brands (for example wavespeed-ai/flux-*). */
export function modelIcon(id?: string | null): string | undefined {
  if (typeof id !== 'string' || !id) return undefined;
  const family = id.toLowerCase();
  const families: Array<[RegExp, string]> = [
    [/krea/, 'krea'], [/longcat/, 'longcat-color'], [/nano-banana/, 'nanobanana-color'], [/flux/, 'flux'], [/qwen/, 'qwen-color'],
    [/kling/, 'kling-color'], [/hailuo/, 'hailuo-color'], [/vidu/, 'vidu-color'],
    [/minimax/, 'minimax-color'], [/hunyuan/, 'hunyuan-color'], [/seedream|seedance/, 'bytedance-color'],
    [/gpt-image|sora/, 'openai'], [/grok/, 'grok'], [/veo/, 'google-color'],
    [/(?:\/|^)wan-/, 'alibaba-color'],
  ];
  const match = families.find(([pattern]) => pattern.test(family));
  if (match) return match[1];
  const providers: Record<string, string> = {
    openai: 'openai', google: 'google-color', bytedance: 'bytedance-color',
    alibaba: 'alibaba-color', 'wavespeed-ai': 'wavespeed', 'black-forest-labs': 'flux',
    kwaivgi: 'kling-color', 'ideogram-ai': 'ideogram', 'stability-ai': 'stability',
    'recraft-ai': 'recraft', minimax: 'minimax-color', runwayml: 'runway',
    pixverse: 'pixverse-color', 'x-ai': 'grok', vidu: 'vidu-color',
    microsoft: 'microsoft-color', meta: 'meta-color', nvidia: 'nvidia-color',
    'pruna-ai': 'prunaai-color', reve: 'reve', 'z-ai': 'zai', topaz: 'topazlabs', midjourney: 'midjourney',
    bria: 'briaai-color', 'bria-ai': 'briaai-color', luma: 'luma', pika: 'pika',
  };
  return providers[family.split('/')[0]];
}
